import { getAuthenticatedRequestInit } from '../connection/utils';
import { getApiHost } from './hosts';
import logger from './logger-rum';

export const CreateIOSNotification = (token: string, emails: string, profiles: string, message: string) => {
	return fetch(`${getApiHost()}/v2/greenroom/ios-notification/create`, {
		method: 'POST',
		body: JSON.stringify({
			emails: emails,
			profiles: profiles,
			message: message,
		}),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (!result.ok) {
			logger.error(`${getApiHost()}/v2/greenroom/ios-notification/create status ${result.status}`);
		}
	});
};
